var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9.39325 16V8.70218H11.8418L12.2092 5.85725H9.39325V4.04118C9.39325 3.21776 9.62097 2.65661 10.8031 2.65661L12.3083 2.65599V0.111384C12.048 0.0775563 11.1545 0 10.1145 0C7.94279 0 6.45602 1.32557 6.45602 3.75942V5.85725H4V8.70218H6.45602V16H9.39325Z","fill":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }